import React, { useEffect, useState } from 'react';

import styles from './PartnerWithUs.module.css'
import Heading from '../components/Heading';

import chargerImage from "./Assets/charger.webp";
import FooterBox from '../components/FooterBox';
import FooterForm from '../components/FooterForm/FooterForm';
import SubHeading from '../components/SubHeading';



const PartnerWithUs: React.FC = () => {


    useEffect(() => {
        document.title = 'Partner With Us | BreatheEV';
    }, []);



    return (
        <main id="main">
            <div className='home-main'>

                <section className={`${styles.partnerWithUs} page-top-margin`}>
                    <div className={`container`} >
                        <span className={styles.subtitle}>Partner With Us</span>
                        <Heading topBottomMargin={14}>OUR CUSTOMERS</Heading>
                        <SubHeading topBottomMargin>
                            <p>Embrace the future with BreatheEV's cutting-edge EV charging solutions. Transform your property, attract more tenants and visitors, and enhance your property's value and NOI. Partner with us to lead the way in the commercial real estate market.</p>
                            <p>Don't just adapt - set the standard. Contact BreatheEV today and electrify your property's appeal.</p>
                        </SubHeading>
                    </div>
                </section>

                <div className={styles.section}>
                    <div className={`container`}>
                        <div className={styles.mainContent}>
                            <img src={chargerImage} />
                            <div className={styles.content}>
                                <h2>What we offer our Customers</h2>
                                <strong>The Complete Solution</strong>
                                <div className={styles.data}>
                                    Transform your property into a modern, eco-friendly community with BreatheEV. Our innovative EV charging solutions are more than just an amenity; they're a statement of your commitment to a sustainable partner. As a valued BreatheEV partner, your property will not only enjoy the benefits of cutting-edge charging technology but also attract a forward-thinking resident demographic. Embrace the opportunity to be a leader in environmental responsibility and resident satisfaction. Don't let your property fall behind in the rapidly evolving world of EV technology. Contact us today, and let's embark on a journey to revolutionize your residents' charging experience and elevate your property's appeal. Be a part of the change – be a part of BreatheEV.
                                </div>
                            </div>
                        </div>

                    </div>



                </div>




                {/* <Home_7 background='#e9ecee' /> */}

                <FooterBox background='#e9ecee'>
                    <FooterForm></FooterForm>
                </FooterBox>

            </div>

        </main>
    );
};

export default PartnerWithUs;
